import {
  IGetApprovalDetail,
  IUpdateStatusApprovalDetail,
} from 'interfaces/Approval';
import {
  IAddApprovalDetail,
  ICheckCreateApprovalDetail,
  IDeleteApprovalDetail,
  IGetAllApproval,
  IUpdateApprovalDetail,
} from './../../../interfaces/Approval/index';

export const APPROVAL_VARIABLE = {
  getAllApproval: ({ skip, take, useYn }: IGetAllApproval) => {
    return {
      skip,
      take,
      input: {
        ...(typeof useYn === 'boolean' && {
          useYn: {
            equals: useYn,
          },
        }),
      },
    };
  },
  getApprovalDetail: ({
    plantId,
    approvalId,
    useYn,
    skip,
    take,
    plantND,
  }: IGetApprovalDetail) => {
    return {
      skip,
      take,
      input: {
        approvalId: {
          equals: approvalId,
        },
        ...(useYn && {
          useYn: { equals: useYn },
        }),
        ...(plantId && {
          plantId: { equals: plantId },
        }),
        ...(plantND && {
          tuser: { plantCode: { equals: plantND } },
        }),
      },
    };
  },
  addApprovalDetail: (params: IAddApprovalDetail) => {
    return {
      input: params,
    };
  },
  deleteApprovalDetail: (params: IDeleteApprovalDetail) => {
    return {
      input: params.id,
    };
  },
  updateApprovalDetail: (params: IUpdateApprovalDetail) => {
    return {
      input: params,
    };
  },
  checkCreateApprovalDetail: ({
    approvalId,
    indexNum,
    userId,
  }: ICheckCreateApprovalDetail) => {
    return {
      input: {
        approvalId,
        ...(indexNum && { indexNum }),
        ...(userId && { userId }),
      },
    };
  },
  updateStatusApprovalDetail: (params: IUpdateStatusApprovalDetail) => {
    return {
      input: params,
    };
  },
};
